var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrioBleu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M35.1866 2.01004C32.7402 2.92369 31.1998 4.38553 30.5656 6.3042C29.297 9.86745 31.7435 14.0703 31.7435 14.1616L51.3151 48.6063V8.86243C51.3151 8.77106 51.3151 3.92871 48.5062 1.46184C47.3283 0.456826 45.8786 0 44.0664 0C43.5227 0 42.8884 0.0913655 42.2542 0.182731L39.0828 1.00502L35.1866 2.01004Z",
    fill: "#0B7189"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M1.933 35.6324L0.936298 39.3783L0.120813 42.6675C-0.241625 45.3171 0.211422 47.4185 1.47995 48.8803C3.65458 51.4385 7.55079 51.7126 8.72871 51.7126H8.81932H48.0532L13.8935 31.9778C13.8935 31.9778 11.2658 30.4246 8.36627 30.4246C7.6414 30.4246 6.82591 30.5159 6.10104 30.79C4.28885 31.5209 2.8391 33.0741 1.933 35.6324Z",
    fill: "#0B7189"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12.4437 17.8163C10.8128 19.8263 10.1785 21.9277 10.5409 23.8464C11.2658 27.5923 15.4339 29.9678 15.4339 30.0592L49.4124 49.8854L29.7502 15.5322C29.7502 15.4408 27.3037 11.238 23.5887 10.5984C23.2263 10.5071 22.8638 10.5071 22.5014 10.5071C20.8704 10.5071 19.2395 11.238 17.5179 12.6085L15.162 14.984L12.4437 17.8163Z",
    fill: "#0B7189"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrioBleu);
export default __webpack_public_path__ + "static/media/trio-bleu.5df9a26116299871e7cacccf3e074ae0.svg";
export { ForwardRef as ReactComponent };